import React from 'react';
import PropTypes from 'prop-types';
import Comment from './comment';
import Pagination from '../pagination';
import AddNew from './addNew';

const Comments = ({
  t,
  count,
  goToPage,
  criteria,
  comments,
  backgroundColor,
  commented,
  submitComment,
  upload_name,
}) => (
  <React.Fragment>
    <div className="cmntboxouter boxs" id="comments">
      <div className="boxs cmntbox">
        <h6>{t('Comments')}<span>{` ( ${count} )`}</span></h6>
        {comments.map(item => (
          <div key={item.id}>
            <Comment item={item} />
          </div>
        ))}
      </div>
    </div>
    <Pagination
      goToPage={goToPage}
      count={count}
      pageSize={criteria.limit}
      page={criteria.page}
      backgroundColor={backgroundColor}
    />
    {commented && <AddNew
      checkKeyPress
      attach
      upload_name={upload_name}
      onSubmit={submitComment}
      label={t('Add your comment')}
      placeholder={t('Start typing, press Enter to send')}
    />
    }
  </React.Fragment>
);

Comments.propTypes = {
  t: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired,
  criteria: PropTypes.object.isRequired,
  comments: PropTypes.array.isRequired,
  commented: PropTypes.bool,
  submitComment: PropTypes.func.isRequired,
  upload_name: PropTypes.string.isRequired,
};

export default Comments;



// WEBPACK FOOTER //
// ./src/components/comments/Comments.jsx